// Generated by purs version 0.15.16
var keyup = "keyup";
var keydown = "keydown";
export {
    keydown,
    keyup
};
//# sourceMappingURL=index.js.map
